import { TypographyProps, TypographyTypeMap } from '@mui/material';
import React from 'react';
import { MarginSpacing } from '../../../commons/styles/spacing';
import { StTypography } from './styles';

export type DefaultTypography = TypographyTypeMap['defaultComponent'];

export type Props<T extends React.ElementType> = {
  component?: T;
  margin?: MarginSpacing;
} & TypographyProps<T>;

export function Typography<T extends React.ElementType = DefaultTypography>({ margin, ...props }: Props<T>) {
  return <StTypography $margin={margin} {...props} />;
}

export default Typography;
